import React, { useContext } from "react";
import { Form, Input, Col, Select, DatePicker } from "antd";
import inputStyles from "../../../styles/Custom/Input.module.css";
import { contactRelationOptions } from "../receptionKeys";
import { PractitionerFormInput } from "../Appointments/PractitionerSearch";
import { UserContext } from "../../../context/UserContext";
import { getCookie } from "../../../helpers/localStorage";
import { FacilityID } from "../../../constants/defaultKeys";
import useReceptionistMobilePickerProps from "../receptionistMobilePickerProps";

const MoreDetails = ({ consultantDisplayName = "" }) => {
  const mobilePickerProps = useReceptionistMobilePickerProps();
  const { userDetails } = useContext(UserContext);
  const facilityId = Number(getCookie(FacilityID)) || userDetails?.currFacility;

  return (
    <>
      <Col xs={24} md={8}>
        <Form.Item
          label="Admission Date"
          name="admission_date"
          rules={[{ required: true, message: "Please select admission date" }]}
        >
          <DatePicker
            {...mobilePickerProps}
            className={inputStyles.mdDateInput}
            format="YYYY-MM-DD"
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item
          label="Emergency Contact Name"
          name="emergency_contact_name"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "Please enter emergency contact name",
            },
            {
              validator: (_, value) => {
                if (!value || !String(value).trim()) {
                  return Promise.resolve();
                }
                if (!/^[a-zA-Z\s]+$/.test(String(value).trim())) {
                  return Promise.reject(
                    new Error("Name can only contain letters and spaces")
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            className={inputStyles.mdInput}
            placeholder="Emergency Contact Name"
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item
          label="Emergency Contact No"
          name="emergency_contact_no"
          rules={[
            { required: true, message: "Please enter mobile number" },
            {
              pattern: /^[0-9]{10}$/,
              message: "Please enter a valid 10-digit phone number",
            },
          ]}
        >
          <Input
            className={inputStyles.mdAddonInput}
            maxLength={10}
            placeholder="Mobile Number"
            addonBefore="+91"
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item
          label="Emergency Contact Relation"
          name="emergency_contact_relation"
          rules={[
            { required: true, message: "Please select emergency contact relation" },
          ]}
        >
          <Select
            allowClear
            placeholder="Select relation"
            options={contactRelationOptions}
            className={inputStyles.mdSelect}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item
          label="Consultant Name"
          name="doctor"
          rules={[
            { required: true, message: "Please select consultant name" },
          ]}
        >
          <PractitionerFormInput
            facilityId={facilityId}
            initialDisplayName={consultantDisplayName}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item label="MLC Number" name="mlc_number">
          <Input
            className={inputStyles.mdInput}
            placeholder="MLC Number"
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default MoreDetails;
